<template>
    <div :class="`as-statics-item ${classModify}`">
        <div class="as-statics-item__head">
            <span class="as-title">{{ mainValue }}%</span>
            <span>{{ title }}</span>
        </div>
        <div class="as-statics-item__content">
            {{ subTitle }}{{ `${subValue ? `: ${subValue}%`: ''}` }}
        </div>
    </div>
</template>
<script setup lang="ts">
    interface Props {
        classModify?: string;
        mainValue: number | string;
        subValue?: number | string;
        title: string;
        subTitle?: string | number;
    }

    const props = withDefaults(defineProps<Props>(), {
        classModify: 'as-orange',
        mainValue: 0,
        subValue: 0,
        title: '',
        subTitle: 'Trung bình giải đấu'
    })
</script>

<script lang="ts">
export default {};
</script>
